// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"4729a2db","133":"cf18e3a7","182":"463e2a90"}[chunkId] + ".chunk.js";
};